module.exports = __webpack_public_path__ + "img/data-analysis.15c515a.svg";